var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_61023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00247 1.99935C6.89787 1.99935 6.00244 2.89478 6.00244 3.99935V6.66602C6.00244 7.77062 6.89787 8.66602 8.00247 8.66602C9.107 8.66602 10.0025 7.77062 10.0025 6.66602V3.99935C10.0025 2.89478 9.107 1.99935 8.00247 1.99935ZM8.00247 0.666016C9.8434 0.666016 11.3358 2.1584 11.3358 3.99935V6.66602C11.3358 8.50695 9.8434 9.99935 8.00247 9.99935C6.16149 9.99935 4.66911 8.50695 4.66911 6.66602V3.99935C4.66911 2.1584 6.16149 0.666016 8.00247 0.666016ZM2.03906 7.33268H3.38304C3.70652 9.59422 5.65146 11.3327 8.00247 11.3327C10.3534 11.3327 12.2983 9.59422 12.6219 7.33268H13.9658C13.6584 10.1137 11.4502 12.3219 8.66914 12.6294V15.3327H7.3358V12.6294C4.5547 12.3219 2.3465 10.1137 2.03906 7.33268Z",
    fill: "url(#paint0_linear_897_61023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5742H9V15.5117H7V12.5742Z",
    fill: "url(#paint1_linear_897_61023)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_897_61023",
    x1: 2.03906,
    y1: 7.99935,
    x2: 13.9658,
    y2: 7.99935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_897_61023",
    x1: 7,
    y1: 14.043,
    x2: 9,
    y2: 14.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_61023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.9aab861dd5f6dbb460a8a18f4dfd86e6.svg";
export { ForwardRef as ReactComponent };